import { auth } from "@/lib/better-auth/auth";
import { inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: process.env.DATABASE_URL!,
  plugins: [inferAdditionalFields<typeof auth>()],
});
